// TODO - Update types
export const isDayInCurrentMonth = (dayToCompare, daysInMonth) => {
    return daysInMonth.find((day) => dayToCompare.utc().isSame(day.customerDate, "month")) !== undefined;
};
// TODO - Update types
export const findSkipDay = (dayToCompare, daysInMonth) => {
    return daysInMonth.find((skipDay) => dayToCompare.utc().isSame(skipDay.customerDate, "day") && skipDay.skip);
};
// TODO - Update types
export const shouldDisableDate = (date, allSkipDays) => {
    let isEligibleSkipDay = allSkipDays.find((skipDay) => date.isSame(skipDay.customerDate, "day"));
    if (!isEligibleSkipDay) {
        return true;
    }
};
/**
 * ACCOUNT > SKIP DAY PAGE > Day Click Handler
 * @param handleOpenWarningModal
 * @param handleUpdateSkipDay
 * @param isDisableDay
 * @param isSkipDay
 * @param setDayToSkip
 * @param targetDay
 * @returns
 */
export const dayChangeHandler = (handleOpenWarningModal, handleUpdateSkipDay, isDisableDay, isSkipDay, setDayToSkip, targetDay) => () => {
    if (!isDayInCurrentMonth || isDisableDay) {
        return console.debug("No action.");
    }
    if (isSkipDay && handleUpdateSkipDay) {
        console.debug("Skip day action.");
        return handleUpdateSkipDay(isSkipDay.customerDate, false);
    }
    if (targetDay && !targetDay.hasMealsAssigned && handleUpdateSkipDay) {
        console.debug("No assigned meals action.");
        return handleUpdateSkipDay(targetDay.customerDate, true);
    }
    if (targetDay && !!targetDay.hasMealsAssigned && setDayToSkip && handleOpenWarningModal) {
        console.debug("Assigned meals action.");
        setDayToSkip(targetDay && targetDay.customerDate);
        return handleOpenWarningModal();
    }
    else {
        return console.debug("No action.");
    }
};
